<template>
  <div class="sigbox">
    <div class="sigcount" v-if="sigs && sigs.length > 0">{{sigs.length}} Signatures.</div>
    <div class="sigline" v-for="sig in sigs" :key="sig.name+sig.country+sig.comment">
      <div class="sigline__name">
        {{sig.name}}
      </div>
      <div class="sigline__country">
        {{sig.country}}
      </div>
      <div class="sigline__comment" v-if="sig.comment && sig.comment !== 'null'">
        "{{sig.comment}}"
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../lib/config';
import surveys from '../../lib/surveys';
export default {
  name: 'Signatures',
  data () {
    return {
      sigs: [
      ]
    }
  },
  props: [
    'signedName', // the just signed details to display at top
    'signedCountry',
    'signedComment'
  ],
  mounted () {
    // console.log('mounted');
    surveys.getSummary(config.SURVEY_GUID).then( (theSurveys) => {
      // console.log(theSurveys);

      // comes back in summary lists without relationship between people :(
      // summary: [
      //  {question1 answers},
      //  {question2 answers},...
      //  and seems to have different number of answers per question.
      // So overloaded the name question b96ceba5-4fd6-4f09-854e-50665ad7ea9f with all values split by \
      let nameAnswers = theSurveys.summary.find(survey => {
        if (survey.guid === 'b96ceba5-4fd6-4f09-854e-50665ad7ea9f') {
          return true;
        }
      })

      // nameANswers.answers is an array of objects: {answer:'', count:1}
      // answer string is name\country\comment
      this.sigs = nameAnswers.answers.map(answerObj => {
        // console.log(answerObj.answer);
        let sp = answerObj.answer.split('\\');
        return {
          name: sp && sp.length > 0 && sp[0] !== '(empty)' ? sp[0] : null,
          country: sp && sp.length > 1 ? sp[1] : null,
          comment: sp && sp.length > 2 ? sp[2] : null,
        }
      });

      // Seems that generally comes in the order in which add to the DB so reverse so that newest-ish to the top
      this.sigs.reverse();

      // The list comes back in random order. Want ours to be at the top. So remove it and add at the top (start)
      // If they have just signed then update to reflect
      // console.log('signedname', this.signedName);
      if (this.signedName) {
        // Remove the item wherever it is
        let filteredSigs = this.sigs.filter(sig => {
          if (sig.name === this.signedName && sig.country === this.signedCountry && sig.comment === this.signedComment) {
            return false;
          } else {
            return true;
          }
        });

        // console.log('before unshift', filteredSigs);
        filteredSigs.unshift({
          name: this.signedName,
          country: this.signedCountry,
          comment: this.signedComment
        });
        this.sigs = Object.assign({}, filteredSigs);
      }
    })
  }

}
</script>

<style scoped lang="scss">
  .sigbox {
    background-color: rgba(238, 232, 170, 0.45);
    padding: 2em;
  }

  .sigcount {
    font-size: 2em;
    font-weight: 800;
    margin-bottom: 1.6em;
  }
  .sigline {
    color: black;
    font-weight: 300;
    font-size: 1em;
    border-top: dotted 1px black;
    &__name {
      margin-left: 3px;
      padding: 6px 3px 6px 3px;
      display: inline-block;
      font-size: 1.3em;
      font-weight: 400;
    }
    &__country {
      margin-left: 3px;
      padding: 6px 3px 6px 3px;
      display: inline-block;
      font-size: 1.3em;
    }
    &__comment {
      margin-left: 3px;
      padding: 6px 3px 6px 3px;
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/Signatures.vue